<div class="col-12 justify-content-center no-gutters py-3" *ngIf="isShow">
  <div class="d-flex">
    <div class="text-title col-10 p-0">{{type === 'application-training-document-admin' ? 'Application Training Documents Admin' : 'Documents Admin'}}</div>
    <div class="col-2 p-- d-flex">
      <div class="border-circle ml-auto mt-2 mr-md-3" (click)="openReadMe()">
        ?
      </div>
      <div class="row no-gutters col-5 d-flex align-items-center justify-content-end p-0">
        <div class="row no-gutters col-4 px-0 d-flex align-items-center justify-content-end">
          <button class="button btn btn-primary button" (click)="addTrainingDocument()">
            ADD
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="row col-12 no-gutters" style="padding-top: 40px;">
    <div class="col-7 text-left align-items-center pt-2">
      ALL Apps: {{applicationDocumentList.length}} Apps
    </div>
  </div>
  <div class="row col-12 no-gutters" style="padding-top: 20px; padding-bottom: 60px;">
    <div class="col-12 text-left align-items-center pt-2">
      Add and modify all training materials to this page
    </div>
    <div class="col-12 text-left align-items-center pt-3" *ngIf="applicationDocumentList.length">
      <table>
        <thead style="background-color: rgb(226, 224, 224);">
          <tr>
            <th class="text-center" id="appName">
              App Name
            </th>
            <th class="text-center" id="email">
              Support Email
            </th>
            <th class="text-center" id="action">
              Action
            </th>
          </tr>
        </thead>
        <tbody *ngFor="let item of applicationDocumentList; let idx=index">
          <tr>
            <td>
              <div class="row col-12">
                <a (click)="updateTrainingDocument(item.id)" class="router-link">
                  <span>
                    {{item?.name}}
                  </span>
                </a>
              </div>
            </td>
            <td *ngIf="item?.emails.length">
              <div *ngFor="let mail of item?.emails; let first = first" class="d-flex">
                <div class="col-10">
                  {{mail?.email}}
                </div>
                <i class="fa fa-pencil col-2 text-right" (click)="openDialog(item, 'edit')"
                  style="cursor: pointer; font-size:20px" [matTooltip]="'Edit'" *ngIf="first"></i>
              </div>
            </td>
            <td *ngIf="!item?.emails.length">
              <div class="row no-gutters col-12 d-flex align-items-start justify-content-start">
                <button class="button btn btn-primary button" (click)="openDialog(item)">
                  <span>
                    ADD
                  </span>
                </button>
              </div>
            </td>
            <td>
              <div class="row col-12 no-gutters d-flex align-items-center justify-content-center">
                <i class="fa fa-eye px-2" (click)="setShowItem(item)" *ngIf="item?.active" [matTooltip]="'Show'"
                  style="cursor: pointer; font-size:20px"></i>
                <i class="fa fa-eye-slash px-2" (click)="setShowItem(item)" *ngIf="!item?.active" [matTooltip]="'Hide'"
                  style="cursor: pointer; font-size:20px"></i>
                <i class="fa fa-trash px-2" aria-hidden="true" [matTooltip]="'Remove'" (click)="delete(item?.id)"
                  style="cursor: pointer; font-size:20px"></i>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-12 text-left align-items-center pt-2" *ngIf="!applicationDocumentList.length">
      <table>
        <thead style="background-color: rgb(226, 224, 224);">
          <tr>
            <th class="text-center" id="appName">
              App Name
            </th>
            <th class="text-center" id="email">
              Support Email
            </th>
            <th class="text-center" id="action">
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="4">No application training documnet</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>